export const SUCCESS = "success"
export const DANGER = "danger"
export const RESPONSE_SUCCESS = "SUCCESS"
export const ID_FEEDBACK = "feedbackDetails"
export const ENTITYDATA_FILTER = ["ONETIME"]
export const SUBMIT_FEEDBACK_ERROR = "submit-feedbackError";
export const SUBMIT_FEEDBACK_SUCCESS = "submit-feedbackSuccess";
